import {Injectable} from '@angular/core';
import {ReportsService} from '../reports.service';
import {appColors} from '../../core/styles/colors';
import {UsersTotalModel} from '../../api/models/users-total-model';

@Injectable()
export class UsersDashboardService {

  public dashboardData: UsersTotalModel = {
    totalsByUser: []
  };

  public selectedFilterType = {action: 99, text: 'Total Calls', field: 'all'};
  public colors = appColors;

  constructor(private reportsService: ReportsService) {

  }
}
